import sanitizeHtml from 'sanitize-html';
const template = document.createElement('template');

const decodeHtmlEntities = (str: string): string => {
  template.innerHTML = str;
  return template.content.textContent || '';
};

/**
 * Sanitize Content
 * @param content any
 * @returns content any
 */
export const sanitizeContent = (content: any) => {
  if (typeof content === 'string') {
    // 먼저 HTML 엔티티를 디코딩한 다음 sanitizeHtml을 적용합니다
    const decodedContent = sanitizeHtml(content);
    return decodeHtmlEntities(decodedContent);
  }

  return content;
};

/**
 * Sanitize a Json Array
 * @param arrayOrObject Array or Object
 * @returns output Array or Object
 */
const sanitizeArrayObject = (arrayOrObject: any) => {
  const output = Array.isArray(arrayOrObject) ? [] : {};

  // loop for an array
  for (const key in arrayOrObject) {
    const item = arrayOrObject[key];
    if (typeof item === 'object' && item instanceof FormData) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      output[key] = item;
    } else if (typeof item === 'object' && item !== null && typeof item.getMonth === 'function') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      output[key] = item;
    } else if (Array.isArray(item) || (typeof item === 'object' && item !== null)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      output[key] = sanitizeArrayObject(item);
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      output[key] = sanitizeContent(item);
    }
  }

  return output;
};

export const sanitizeData = (inputVal: any) => {
  try {
    if (typeof inputVal === 'object' && inputVal instanceof FormData) {
      return inputVal;
    }

    if (Array.isArray(inputVal) || (typeof inputVal === 'object' && inputVal !== null)) {
      return sanitizeArrayObject(inputVal);
    }

    return sanitizeContent(inputVal);
  } catch (e) {
    console.error('parse error', e);
  }
};

export const isRequestSuccessful = (code: number) => {
  return code >= 200 && code <= 204;
};
